import { ProjectsShowcase } from 'components/showcases/ProjectsShowcase'
import { useParams } from 'react-router-dom'

export const ProjectsByTechPage = () => {
    // projects/:technologySelected
    const { technologySelected } = useParams()
    const mainTechnology = technologySelected
        ? technologySelected.toUpperCase()
        : 'PROJECTS'

    return (
        <div className="projectsbytype">
            <h1 className="projectsbytype__title">{mainTechnology}</h1>
            <section className="projectsbytype__container">
                <ProjectsShowcase />
            </section>
        </div>
    )
}